// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__hDbab","alert":"SettungsInbox_alert__2JBVb"};